import React from "react"
import "./ThemeContainer.scss"
import cn from "classnames"
import SpinnerContainer from "../load/SpinnerContainer"
import { useSelector } from "react-redux"
import { settingsSelectors } from "@/slices/settingsSlice"

interface IThemeContainerProps {
  children: React.ReactNode
}

export function ThemeContainer({ children }: IThemeContainerProps) {
  const settings = useSelector(settingsSelectors.settings)
  const isLoading = useSelector(settingsSelectors.isLoading)
  return (
    <SpinnerContainer
      showSpinner={!!isLoading}
      aboveContent
      spinnerClassName="theme-spinner"
      className="theme-loader"
    >
      <div className={cn("theme-container", "theme-container--" + (settings?.themeType ?? "none"))}>
        {children}
      </div>
    </SpinnerContainer>
  )
}
